import React from 'react';
import Translate from '@spordle/intl-elements';

import { SEASONS } from '@hisports/common/src/seasons';

import BaseEnumFilter from './BaseEnumFilter';

export default ({ name = 'seasonId', label = <Translate id="components.filters.season" />, ...props }) =>
  <BaseEnumFilter
    name={name}
    label={label}
    options={SEASONS}
    isClearable={false}
    {...props}
  />
